import { Box, Typography, Button } from "@mui/material";
import CopyContact from "./CopyContact.js";
import { Link } from "react-router";

export default function GetInTouch() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        my: 4,
      }}
    >
      <Typography
        variant="h3"
        sx={{ textAlign: "center", mb: 2, fontWeight: 800 }}
      >
        Get in touch
      </Typography>
      <Typography variant="body1" sx={{ textAlign: "center", mb: 2 }}>
        I am always looking forward to cooperation on any software engineering / Computer Science - related
        projects. If you need assistance with yours, have any questions about my experience or would like to
        stay informed on my progress, feel free to get in touch or follow me on social media:
      </Typography>
      <CopyContact contact="hello@vladhere.com" />
      <Link to="contacts">
        <Button variant="outlined" size="large" sx={{ mt: 2 }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#2C2C2C"
          >
            <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />
          </svg>
          More contact details
        </Button>
      </Link>
    </Box>
  );
}
